import Load from 'components/Load';
import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';

const AsyncPostPayment = Load(
  () =>
    import(/* webpackChunkName: "post-payment-pages" */ './PostPaymentRoutes'),
);

function renderAsyncConfirmation(props) {
  return <AsyncPostPayment key="post-payment" {...props} />;
}

const ConfirmationRoute = (
  <Route
    key="confirmation"
    path={`${basePath}/confirmation/:paymentId`}
    render={renderAsyncConfirmation}
  />
);

export default ConfirmationRoute;
